import { Component } from '@angular/core';

@Component({
  selector: 'app-home',
  templateUrl: './full-layout.component.html'
})
export class FullLayoutComponent { }
